export const STORAGE_KEYS = {
  EXAMPLE_STORAGE: "exampleStorage",
  AUTH_STORAGE: "authStorage",
  WAITING_TOOLS_STORAGE: "waitingToolsStorage",
  HAS_PARSE_ISSUE: "hasParseIssue",
} as const;
